// extracted by mini-css-extract-plugin
export default {"dropdown":"PageDropdown_dropdown__3FWj1","title":"PageDropdown_title__I9X2N"};